import _global3 from "../internals/global";
import _isCallable from "../internals/is-callable";
var exports = {};
var _global2 = _global3;
var isCallable = _isCallable;
var WeakMap = _global2.WeakMap;
exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));
export default exports;